var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-section"},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":"/img/Dimitra_logo_white.png"}}),_c('h4',{staticClass:"white--text text-h6 font-weight-black"},[_vm._v("DIMITRA")])])])
}]

export { render, staticRenderFns }